import { useEffect, useRef, useState } from 'react'
import './index.scss'
import View from '../Base/View';
import Text from '../Base/Text';
import Productinfoinorder from '../ProductInfoInOrder';
import Block from '../Base/Block';
import Price from '../Price';
import PayOrderPanel, { PayOrderPanelRef } from '../PayOrderPanel';
import rm from '../../utils/rm';
import { toast } from '../../utils/toast';
import orderManager from '../../manager/order';
import util from '../../utils/util';

const OrderListItem = (prop: {
    orderInfo: any,
    onOrderCanceled?: (orderInfo: any) => void,
    onRefundOrder?: () => void,
    onOpenShipmentDialog?: (productInfo: any) => void,
    onOrderPayed?: (orderInfo: any) => void,
    onOrderConfirmed?: (orderInfo: any) => void,
}) => {

    const isOperating = useRef<boolean>(false);
    const [orderInfo, setOrderInfo] = useState<any>(prop.orderInfo);
    const payRef = useRef<PayOrderPanelRef>();

    useEffect(() => {
        setOrderInfo(prop.orderInfo)
    }, [prop.orderInfo])

    const _onProductListClick = () => {
        if (orderInfo.Id > 0) {
            util.navigateTo('/order/order?isrmmp=1&hidemenu=1&id=' + orderInfo.Id)
        }
    }

    const _openShipmentListDialog = (productInfo: any) => {
        if (prop.onOpenShipmentDialog) {
            prop.onOpenShipmentDialog(productInfo)
        }
    }

    const refundOrder = () => {
        if (prop.onRefundOrder) {
            prop.onRefundOrder()
        }
    }

    const _cancelOrder = () => {
        if (isOperating.current) {
            return
        }
        rm.showModal({
            title: '确认取消此订单？',
            content: '',
            showCancel: true,
            cancelText: '不取消',
            confirmText: '确定',
            cancelColor: '#333333',
            confirmColor: '#e74737',
        }, (res) => {
            if (res.confirm) {
                isOperating.current = true
                toast.loading('处理中', 0, "cancel")
                orderManager.cancelOrder(
                    orderInfo.Id,
                    function (success: boolean, data: any, tips: string) {
                        if (success) {
                            const newOrderInfo = Object.assign({}, orderInfo, {
                                OrderStatus: "已取消",
                                OrderStatusId: 50,
                            })
                            setOrderInfo(newOrderInfo)
                            if (prop.onOrderCanceled) {
                                prop.onOrderCanceled(newOrderInfo)
                            }
                        }
                        toast.destory("cancel")
                        toast.info(tips)
                        isOperating.current = false
                    }
                )
            }
        })
    }

    const _payOrder = () => {
        if (isOperating.current) {
            return
        }
        isOperating.current = true;
        var payParam = {
            OrderId: orderInfo.Id,
            CustomerWxOpenIdObtained: false,
            OrderInfo: orderInfo,
        }
        toast.loading('支付中', 0, "pay")
        payRef.current?.request(payParam, function (state: string, data, tips) {
            toast.destory("pay")
            toast.info(tips)
            console.log('订单支付成功', state, data, tips)
            if (state === 'success') {
                const newOrderInfo = Object.assign({}, orderInfo, {
                    OrderStatus: "待发货",
                    OrderStatusId: 20,
                })
                setOrderInfo(newOrderInfo)
                console.log('改变订单状态', newOrderInfo)
                if (prop.onOrderPayed) {
                    prop.onOrderPayed(newOrderInfo)
                }
            }

            isOperating.current = false;
        })
    }

    const _confirmOrder = () => {
        if (isOperating.current) {
            return
        }
        var that = this
        rm.showModal({
            title: '是否确认收货？',
            content: '',
            showCancel: true,
            cancelText: '取消',
            confirmText: '确定',
            cancelColor: '#333333',
            confirmColor: '#e74737',
        }, (res) => {
            if (res.confirm) {
                isOperating.current = true;
                toast.loading('确认中', 0, "_confirmOrder")
                orderManager.confirmOrder(
                    orderInfo.Id,
                    function (success: boolean, data: any, tips: string) {
                        if (success) {
                            const newOrderInfo = Object.assign({}, orderInfo, {
                                OrderStatus: "已完成",
                                OrderStatusId: 40,
                            })
                            setOrderInfo(newOrderInfo)
                            if (prop.onOrderConfirmed) {
                                prop.onOrderConfirmed(newOrderInfo)
                            }
                        }
                        toast.destory("_confirmOrder")
                        toast.info(tips)
                        isOperating.current = false
                    }
                )
            }
        })
    }

    if (!orderInfo) {
        return null;
    }

    return <View className="order-list-item-c">
        <View
            className="order-list-item-header flex-conainer"
            onClick={_onProductListClick}
        >
            <Text className="flex-grow">
                {'订单号: ' + orderInfo?.CustomOrderNumber}
            </Text>
            {orderInfo?.OrderStatusId == 10 ? (
                <Text className="left-time">{orderInfo?.leftTimeStr}</Text>
            ) : (
                <Text className="order-status">{orderInfo?.OrderStatus}</Text>
            )}
        </View>
        {/*  购买商品信息  */}
        <View onClick={_onProductListClick}>
            {orderInfo?.Items?.map((productInfo: any, index: number) => {
                return (
                    <Block>
                        <Productinfoinorder
                            productInfo={productInfo}
                            orderInfo={orderInfo}
                            showShipmengBtn={true}
                            showBottomBorder={index != orderInfo?.Items?.length - 1}
                            onRequestOpenShipmentDialog={_openShipmentListDialog}
                        ></Productinfoinorder>
                    </Block>
                )
            })}
        </View>
        {/*  计件，价格  */}
        <View className="order-list-item-price">
            {'共' + orderInfo?.Items?.length + '件商品　合计:'}
            <Price
                value={orderInfo?.OrderTotal}
                size={30}
                color="#000000"
            ></Price>
        </View>
        {/*  取消、付款按钮  */}
        {(orderInfo?.OrderStatusId == 10 ||
            orderInfo?.OrderStatusId == 20 ||
            orderInfo?.OrderStatusId == 30) && (
                <View className="flex-conainer">
                    <View className="flex-grow"></View>
                    {orderInfo?.OrderStatusId == 10 && (
                        <View className="flex-fix order-cancel-btn" onClick={_cancelOrder}>
                            取消订单
                        </View>
                    )}
                    {orderInfo?.OrderStatusId == 20 && (
                        <Block>
                            <View
                                className="flex-fix order-refund-btn"
                                onClick={refundOrder}
                            >
                                {orderInfo?.CancelRequestStatusId == 1 ? (
                                    <Block>退款进度</Block>
                                ) : orderInfo?.CancelRequestStatusId == 2 ? (
                                    <Block>退款结果</Block>
                                ) : (
                                    <Block>申请退款</Block>
                                )}
                            </View>
                        </Block>
                    )}
                    {orderInfo?.OrderStatusId == 10 && (
                        <PayOrderPanel
                            ref={payRef}>
                            <View className="flex-fix order-pay-btn" onClick={_payOrder}>
                                去付款
                            </View>
                        </PayOrderPanel>
                    )}
                    {orderInfo?.OrderStatusId == 30 && (
                        <View
                            className="flex-fix order-confirm-btn"
                            onClick={_confirmOrder}
                        >
                            确认收货
                        </View>
                    )}
                </View>
            )}
    </View>
}

export default OrderListItem;